import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-export-import-error',
  templateUrl: './export-import-error.component.html',
  styleUrls: ['./export-import-error.component.scss']
})
export class ExportImportErrorComponent implements OnInit {

  constructor() { }

  public ngOnInit() {
  }

}
